import { render, staticRenderFns } from "./DialogImportCustomers.vue?vue&type=template&id=36327599&scoped=true&"
import script from "./DialogImportCustomers.vue?vue&type=script&lang=ts&"
export * from "./DialogImportCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./DialogImportCustomers.vue?vue&type=style&index=0&id=36327599&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36327599",
  null
  
)

export default component.exports